import { render } from "./ExpiredLink.vue?vue&type=template&id=775089f6&scoped=true"
import script from "./ExpiredLink.vue?vue&type=script&lang=js"
export * from "./ExpiredLink.vue?vue&type=script&lang=js"

import "./ExpiredLink.vue?vue&type=style&index=0&id=775089f6&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775089f6"]])

export default __exports__